import { flow } from '@hcr/utils'

import { createActivityValidity } from './createActivityValidity'

export const createActivityValidityString = flow(createActivityValidity, ({ date, label }) => `${label} ${date}`)
